<section>
  <p>Cerrando la sesión con Wise ID, espere un momento por favor...</p>
</section>
